'use client';

import React from 'react';
import Helmet from 'react-helmet';

export const PreconnectLinks = () => {
  return (
    <Helmet>
      <link rel="dns-prefetch" href="https://www.googletagmanager.com" />
      <link rel="dns-prefetch" href="https://dev.visualwebsiteoptimizer.com" />
      <link rel="preconnect" href="https://widget.as.criteo.com" />
      <link rel="preconnect" href="https://static-tracking.klaviyo.com" />
      <link rel="preconnect" href="https://capture.trackjs.com" />
      <link rel="preconnect" href="https://tag.rmp.rakuten.com" />
      <link rel="preconnect" href="https://googleads.g.doubleclick.net" />
      <link rel="preconnect" href="https://www.googletagmanager.com" />
      <link rel="preconnect" href="https://connect.facebook.net" />
    </Helmet>
  );
};
